import { ChartLine } from 'lucide-react';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import GenericEditor from '../../containers_v2/reports/generic/genericEditor';
import { Reports } from '../../containers_v2/reports/Reports';
import { PrimaryColor } from '../../styles/global/css/Utils';
import { Route } from '../Routes';

const ReportsRoutes = (): Route[] => [
	{
		component: Reports,
		path: '/reports',
		name: <Translate id="sidebar.monitoring_and_analysis" />,
		key: 'reports',
		sectionKey: 'reports',
		logoImg: <ChartLine size='16' />,
		hoverImg: <ChartLine color={PrimaryColor} size='16' />,
		activeImg: <ChartLine color={PrimaryColor} size='16' />,
		title: 'Reports',
		subTitle: 'Reports',
		permission: ['ViewReporting', 'ViewGallery', 'ViewObjective'],
		restricted: false,
		exact: true,
		menu: true,
		precedence: 2,
		subroutes: [
			{ path: '/reports', name: <Translate id="general.reports" />, permission: ['ViewReporting'], hashs: ['#list', '#generic'] },
			{ path: '/form-instance-list', name: <Translate id="gallery.title" />, permission: ['ViewForm'], hashs: ['#gallery'] },
		]
	},
	{
		component: GenericEditor,
		path: '/reportEditor',
		key: 'reports',
		sectionKey: 'reports',
		title: 'Reports',
		subTitle: 'Reports',
		admin: true,
		restricted: false,
		exact: true
	}
];

export default ReportsRoutes;
